import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphql } from '../../../../common/useRetriableGraphqlVars';
import { QUERY_GET_EQUIPMENT_FPO_COMMENTS } from '../../../../graphql/queries/infralistComment';

const options = {
  query: QUERY_GET_EQUIPMENT_FPO_COMMENTS,
  mapData: (result) => result.infralistRvpoEquipmentFpoCommentaries,
  skipQuery: skipIfNull(null)
};

export function useFetchEquipmentFPOComments(equipmentId) {
  const response = useRetriableGraphql({
    queryOptions: options,
    variables: {
      rvpo_equipment_id: equipmentId
    },
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
  const data = response.state.data;

  return data ?? [];
}
